/* eslint-disable @typescript-eslint/no-unused-vars */

let LoggerClass;

const config = {
  MI_LOG_LEVEL: 'DEBUG', // will be override by ENV variable
  PERF_LOGGING_ENABLED: 'true',
};

if (process.browser) {
  LoggerClass = class Logger {
    getLogger() {
      const LOG_LEVEL = (process.env.MI_LOG_LEVEL ?? config.MI_LOG_LEVEL).toLowerCase();
      if (LOG_LEVEL === 'debug') {
        return {
          log: console.log,
          warn: console.warn,
          info: console.log,
          error: console.error,
          debug: console.log,
        };
      }
      if (LOG_LEVEL === 'error') {
        return {
          log: () => {
            /* TODO document why this method 'log' is empty */
          },
          warn: () => {
            /* TODO document why this method 'log' is empty */
          },
          info: () => {
            /* TODO document why this method 'log' is empty */
          },
          error: console.error,
          debug: () => {
            /* TODO document why this method 'log' is empty */
          },
        };
      }
      return {
        log: () => {
          /* TODO document why this method 'log' is empty */
        },
        warn: () => {
          /* TODO document why this method 'log' is empty */
        },
        info: () => {
          /* TODO document why this method 'log' is empty */
        },
        error: () => {
          /* TODO document why this method 'log' is empty */
        },
        debug: () => {
          /* TODO document why this method 'log' is empty */
        },
      };
    }
  };
} else {
  /* eslint-disable global-require */
  const os = require('os');
  const Winston = require('winston');
  const { createLogger, format, transports } = Winston;
  const { combine, timestamp, label, errors, printf } = format;
  /* eslint-enable global-require */

  /**

   * Logger class to fetch instances for logging with custom formatting enabled

   */

  LoggerClass = class Logger {
    constructor(requestIdentifiers) {
      this.logPrefix = this.getLogPrefix();
      this.requestIdString = this.getRequestIdentifierString(requestIdentifiers || {});
    }

    /**
     * Get the prefix for the log statement containing the log prefix from environment
     * (if available) and the hostname
     *
     * @returns {String} Prefix for the logging statement
     */
    getLogPrefix() {
      const hostName = os.hostname().toUpperCase();
      const logPrefix = process.env.LOG_PREFIX;

      return logPrefix ? `${logPrefix}|${hostName}` : hostName;
    }

    /**
     * Get the request identifier string for the log statement
     * consisting of the session id and the request id
     *
     * @param {Object} requestIdentifiers Request identifiers as received in the constructor
     * @returns {String} String consisting of session id and request id as available
     */
    getRequestIdentifierString(requestIdentifiers) {
      let requestIdString = '';
      const { sessionID, requestID } = requestIdentifiers;

      requestIdString += sessionID ? ` [SESSION ID: ${sessionID}]` : '';
      requestIdString += requestID ? ` [REQUEST ID: ${requestID}]` : '';

      return requestIdString;
    }

    /**
     * Achieve the following format for timestamp:
     * 2017-05-23 11:35:43.673
     *
     * @returns {String} Formatted Date string
     */
    getTimeStampFormat() {
      return new Date().toISOString().replace('Z', '').split('T').join(' ');
    }

    /**
     * Achieve the following format for the log statement:
     * 2017-05-23 12:25:54.292 [<LOG_PREFIX>] [SESSION ID: <SESSION_ID>] [REQUEST ID: <REQUEST_ID>] [<LOG_LEVEL>] [<LOGGER_NAME>] - <MESSAGE>
     *
     * @param {Object} options Winston options for custom formatting
     * @returns {String} Custom logging format
     */
    // getFormatterString(options) {
    //   return `|LOG_LINE| ${options.timestamp()} [${options.level.toUpperCase()}] [${this.logPrefix}]${this.requestIdString} [${this.loggerName}] - ${options.message ? options.message : ''}`;
    // }

    getFormatterString = printf(
      ({
        // eslint-disable-next-line no-shadow
        level,
        message,
        label,
        timestamp,
        stack,
      }) =>
        `|LOG_LINE| ${timestamp} [${level.toUpperCase()}] [${this.logPrefix}]${this.requestIdString} [${label}] - ${
          message || ''
        } ${stack || ''}`
    );

    /**
     * Get the logger instance with request identifiers as part of formatter
     *
     * @param {String} loggerName Name to identify the log initiator
     */
    getLogger(loggerName) {
      return createLogger({
        level: (process.env.MI_LOG_LEVEL ?? config.MI_LOG_LEVEL).toLowerCase(),
        format: combine(
          label({ label: loggerName }),
          timestamp({
            format: this.getTimeStampFormat,
          }),
          errors({ stack: true }),
          this.getFormatterString
        ),
        transports: [new transports.Console()],
      });
    }
  };
}

/**
 * Constructor for PerfLogger
 *
 * @param {Object} logger Logger instance to be used
 * @constructor
 */
class PerfLogger {
  constructor(log) {
    this.logger = log;
    // turn on/off perf logging
    this.isPerfLoggingEnabled = (process.env.PERF_LOGGING_ENABLED || config.PERF_LOGGING_ENABLED) === 'true';
  }

  /**
   * End and return the ops time
   *
   * @param {String} start Perf logging start time
   * @param {Number} end Perf logging end time
   * @returns {Number} Time difference for ops involved
   * @private
   */
  getOpsTime(start, end) {
    return ((end - start) / 1000).toFixed(3);
  }

  /**
   * End timer and log response time
   *
   * @param {String} message Primary message for logger
   * @param {Number} start Perf logging start time
   * @param {Number} end Perf logging end time
   */
  log(message, start, end) {
    if (!this.isPerfLoggingEnabled) return;

    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    process.nextTick(() => {
      self.logger.error(`[PERFLOG] ${message} ${self.getOpsTime(start, end)} secs.`);
    });
  }
}

const sanitizeArg = arg => {
  if (typeof arg === 'object') {
    try {
      return JSON.stringify(arg); // Convert objects to string safely
    } catch (err) {
      return '[Unserializable Object]'; // Handle circular refs & unserializable data
    }
  }
  return String(arg); // Ensure all values are strings
};

class HarnessLogger {
  constructor(level = 'info') {
    this.level = level; // Only this level will be logged
  }

  // Log only if the level matches the configured level
  log = (level, message, ...args) => {
    if (level === this.level) {
      const sanitizedMessage = String(message); // Convert message to string to avoid injection
      const sanitizedArgs = args.map(arg => sanitizeArg(arg)); // Sanitize each argument
      console.log(`[HARNESS FF][${level.toUpperCase()}]:`, sanitizedMessage, ...sanitizedArgs);
    }
  };

  // Define log level methods as arrow functions
  debug = (message, ...args) => {
    this.log('debug', message, ...args);
  };

  info = (message, ...args) => {
    this.log('info', message, ...args);
  };

  warn = (message, ...args) => {
    this.log('warn', message, ...args);
  };

  error = (message, ...args) => {
    this.log('error', message, ...args);
  };
  trace = (message, ...args) => {
    this.log('debug', message, ...args);
  };
}

// Instantiate the Harness logger with the desired level
const harnessLogger = new HarnessLogger('ERROR'.toLowerCase()); //Keeping Log Level Error always.

export const logger = ids => loggerName => {
  const log = new LoggerClass(ids).getLogger(loggerName);
  return {
    log,
    pLog: new PerfLogger(log),
    harnessLogger: harnessLogger,
  };
};
